import styled from 'styled-components';
import {
    Card,
} from "@mui/material";

export const DetailsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    padding: 10px 0px;
    // display: grid;
    // grid-template-columns: auto;
    // gap: 30px;
    overflow: visible !important;
`;

export const PriceSettingsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    margin: 30px 0px 0px 0px;
    width: 50%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 0.1fr;
    gap: 10px;

    .settingItemHeader {
        grid-column: span 4;
        font-size: 1.09375rem;
        font-weight: 600;
    }

    .settingItemFieldHeader {
        font-size: 0.80rem;
        font-weight: 600;
    }

    .span2Item {
        grid-column: span 2;
    }

    .moduleDropdown {
        grid-column: span 2;
    }

    &:first-of-type {
        margin: 0px !important;
    }
`;